const steelRodWireWorkService = {
  title: "Steel Rod & Wire Work",
  icon: "🧵",
  shortDescription:
    "Rebar tying, rod bending, structural wire work, fabrication, and industrial steel-wire support.",
  longDescription:
    "Book steel rod and wire work support for rebar cutting and tying, reinforcement placement, wire fabrication, industrial mesh work, and specialized steel-wire production support. Site complexity, quantity, gauge, machine dependency, and safety needs can materially affect pricing.",
  consultationNote:
    "Factory-grade production support, high-volume rebar work, custom die preparation, and heavy fabrication jobs should begin with inspection or scope confirmation.",
  responsePromise:
    "Assignment depends on skill match, site safety, machine access, shift length, and local worker availability.",
  warrantyPolicy:
    "Execution support and fabrication quality depend on site conditions, steel quality, design load, and approved work scope.",
  subServices: [
    {
      id: "steel-wire-wire-drawer-operator",
      title: "Wire Drawer / Drawing Machine Operator",
      icon: "🏭",
      group: "Manufacturing & Production",
      description:
        "Industrial operator support for drawing thick steel rods through dies into thinner wire gauges.",
      basePrice: 2499,
      priceType: "starts_at",
      duration: "1 shift",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "steel-wire-rod-mill-operator",
      title: "Wire Rod Mill Operator / Fitter",
      icon: "⚙️",
      group: "Manufacturing & Production",
      description:
        "Rolling mill support for heating, rolling, fitting, and handling steel into coiled wire rods.",
      basePrice: 2899,
      priceType: "starts_at",
      duration: "1 shift",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "steel-wire-die-maker",
      title: "Die Maker",
      icon: "🛠️",
      group: "Manufacturing & Production",
      description:
        "Precision die making or maintenance support for shaping steel wire accurately during production.",
      basePrice: 3499,
      priceType: "starts_at",
      duration: "Per job / shift",
      warranty: "Execution support",
      unit: "job",
    },
    {
      id: "steel-wire-rodbuster",
      title: "Rodbuster (Reinforcing Ironworker)",
      icon: "🏗️",
      group: "Construction & Structural Work",
      description:
        "Cutting, bending, placing, and tying steel rebar and reinforcing mesh for concrete works.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "1 shift",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "steel-wire-steel-tier",
      title: "Steel Tier / Wire Binder",
      icon: "🔩",
      group: "Construction & Structural Work",
      description:
        "Binding and tying intersecting steel rods with steel wire before slab, beam, or footing pours.",
      basePrice: 1199,
      priceType: "starts_at",
      duration: "1 shift",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "steel-wire-wire-fabricator",
      title: "Wire Fabricator",
      icon: "🧰",
      group: "Metal Fabrication & Crafting",
      description:
        "Cutting, bending, and welding wire to create end-products such as mesh, baskets, cages, and trolley structures.",
      basePrice: 1699,
      priceType: "starts_at",
      duration: "Per job",
      warranty: "Execution support",
      unit: "job",
    },
    {
      id: "steel-wire-blacksmith-weaver",
      title: "Blacksmith / Wire Weaver",
      icon: "🔥",
      group: "Metal Fabrication & Crafting",
      description:
        "Traditional or specialized steel rod shaping and manual or semi-automatic wire weaving support.",
      basePrice: 1899,
      priceType: "starts_at",
      duration: "Per job",
      warranty: "Execution support",
      unit: "job",
    },
    {
      id: "steel-wire-inspection",
      title: "Steel Rod / Wire Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for plant setup, rebar work scope, fabrication planning, or industrial steel-wire assessment.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default steelRodWireWorkService;
